import { Component, signal, OnInit } from '@angular/core';
import { AuthService } from '../../../core/service/auth/auth.service';
import { ClubService, Club } from '../../../core/service/club-service/club-service';

@Component({
  selector: 'app-main-layout',
  standalone: false,
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {
  club = signal<Club | null>(null);
  federationLogoUrl = signal<string | null>(null);
  accessLevel = signal<'full' | 'readonly' | 'blocked'>('readonly');
  isLoading = signal(true);

  constructor(
    private authService: AuthService,
    private clubService: ClubService
  ) {}

  ngOnInit(): void {
    this.loadClub();
  }

  private loadClub(): void {
    this.accessLevel.set(this.authService.getAccessLevel());

    const federation = this.authService.getFederation();
    if (federation?.logo_url) {
      this.federationLogoUrl.set(federation.logo_url);
    }

    if (!this.authService.isClub()) {
      this.club.set(null);
      this.isLoading.set(false);
      return;
    }

    const cachedResponse = this.clubService.getClubFromCache();

    if (cachedResponse) {
      this.club.set(cachedResponse.club);
      this.federationLogoUrl.set(cachedResponse.federation?.logo_url || null);
      this.isLoading.set(false);
    } else {
      this.isLoading.set(false);
    }
  }

  logout(): void {
    // Logout is handled in header component
  }
}
